// extracted by mini-css-extract-plugin
module.exports = {"notice":"_3EpMY","clickable":"_2fQJ2","noticeIcon":"_127sM","content":"_36pFi","header":"I3vdh","text":"_135t-","title":"_1GyWT","closeIcon":"_3uB-x"};